import { useInfiniteQuery } from 'react-query';

interface Option {
  value: string;
  label: string;
}

export interface FetchOptionsResponse {
  data: Option[];
}

const DEFAULT_PAGE_SIZE = 20;

export const useSelectOptions = (
  search: string,
  fetchOptions: (
    page: number,
    pageSize: number,
    searchText: string
  ) => Promise<FetchOptionsResponse>,
  key: string
) => {
  return useInfiniteQuery<FetchOptionsResponse>(
    [key, search],
    ({ pageParam = 1 }) => fetchOptions(pageParam, DEFAULT_PAGE_SIZE, search),
    {
      getNextPageParam: (lastPage, pages) => {
        return lastPage.data.length === DEFAULT_PAGE_SIZE
          ? pages.length + 1
          : undefined;
      },
      keepPreviousData: true,
    }
  );
};
